// extracted by mini-css-extract-plugin
module.exports = {"countdownTime":"CountdownText_countdownTime_30dG6"};